<p>nt-abstract-comp works!</p>
